'use strict';

const _ = require('lodash');

function AppController ($state, AppService, Flux, SaturnGrowl, IdentityService) {
  const vm = this;
  const AppStore = Flux.Store.get('AppStore');
  const ManagerStore = Flux.Store.get('ManagerStore');
  const SiteStore = Flux.Store.get('SiteStore');

  vm.requireCompleteSignIn = false;

  vm.getPageClass = () => {
    return AppService.getPageClass();
  };

  vm.handleProcessingNotification = (id) => {
    SaturnGrowl.newGrowl('A processing request has been updated!', {
      type: 'success',
      time: 3500,
      id: 'processing',
      cta: {
        callback: () => {
          $state.go('manager.processingJobs.job', {
            'job': id
          });
        }
      }
    });
  };

  vm._handleCompletedSignInCheck = () => {

    const hasRequireCompleteSignInMeta = function (user = {}) {
      return _.find(user.meta, { key: 'requireCompleteSignIn' });
    };

    vm.requireCompleteSignIn = hasRequireCompleteSignInMeta(IdentityService.getUser());
  };

  vm._handleDisplayGrowl = (text, config = { id: 'generic-growl' }) => {

    if (!text) {
      console.warn('text is required');
      return;
    }

    SaturnGrowl.newGrowl(text, config);
  };

  AppStore.on(AppStore.Events.CheckCompleteSignIn, vm._handleCompletedSignInCheck.bind(vm));
  AppStore.on(AppStore.Events.DisplayGrowl, vm._handleDisplayGrowl.bind(vm));
  ManagerStore.on(ManagerStore.Events.Changed, vm.handleProcessingNotification.bind(vm));
}

AppController.$inject = ['$state', 'AppService', 'sbFlux', 'SaturnGrowl', 'IdentityService'];

module.exports = AppController;



// WEBPACK FOOTER //
// ./src/app/AppController.js